// src/Pages/Cafe24/Cafe24Entry.jsx
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Cafe24Entry = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const mallId = searchParams.get('mall_id');
        const timestamp = searchParams.get('timestamp');
        const hmac = searchParams.get('hmac');


        if (!mallId) {
            console.error('mall_id가 없습니다.');
            return;
        }

        // TODO: HMAC 검증 (선택사항, 백엔드에서 하는 게 더 안전)

        // OAuth 인증 시작
        startOAuth(mallId);
    }, [searchParams]);

    const startOAuth = (mallId) => {
        const state = `${mallId}_${generateRandomString()}`;
        const authUrl =
            `https://${mallId}.cafe24api.com/api/v2/oauth/authorize?` +
            `response_type=code&` +
            `client_id=${process.env.REACT_APP_CAFE24_CLIENT_ID}&` +
            `state=${encodeURIComponent(state)}&` +
            `redirect_uri=${encodeURIComponent(process.env.REACT_APP_CAFE24_REDIRECT_URI)}&` +
            `scope=mall.read_application,mall.write_application`;

        console.log('OAuth 인증 시작:', authUrl);
        window.location.href = authUrl;
    };

    const generateRandomString = () => {
        return Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="flex flex-col items-center space-y-4">
                <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                <div className="text-gray-600 font-medium text-sm">카페24 인증 중...</div>
            </div>
        </div>
    );
};

export default Cafe24Entry;